import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';

const Loading = function ({isShow = true}) {
  return (
    <div
      style={{
        display: isShow ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 15,
        marginBottom: 10,
        width: '100%',
      }}
    >
      資料載入中
      <FontAwesomeIcon icon={faSpinner} pulse size={'1x'} />
    </div>
  );
};

export default Loading;
